function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMyWishlistClick = function SvgMyWishlistClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M700.9 122.5c-71.5 0-138.6 29-191.7 82.3-44.7-50.8-114.1-82.3-185-82.3-140.8 0-259.6 118.9-259.6 259.6C64.6 626 346.5 845.6 504.3 900c2.7.9 5.5 1.4 8.3 1.4s5.6-.5 8.3-1.4c157.8-54.4 439.7-274 439.7-517.9-.1-140.7-119-259.6-259.7-259.6z",
    style: {
      fill: "#d90b17"
    }
  }));
};
export default SvgMyWishlistClick;